export default __webpack_public_path__ + "img/coiAVPvz.36b30945.svg";